<template>
  <div class="main">
    <el-container>
      <el-aside width="300px">
        <el-form :model="addFenceForm"
                 ref="addFenceFormRef"
                 :rules="addFenceFormRules"> 
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('polygonalFence.fenceName')" prop="fenceName" label-width="50">
                <el-input v-model="addFenceForm.fenceName" class="addFenceColumn" :disabled="isPlatformUser"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="搜救员" prop="userId" label-width="70">
                <el-select v-model="addFenceForm.userId"
                           placeholder="请选择搜救员"
                           size="small"
                           @change="getUserList"
                           class="addFenceColumn"
                           :disabled="isPlatformUser">
                  <el-option v-for="user in userList"
                             :key="user.userId"
                             :value="user.userId"
                             :label="user.userName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row>
          <el-col :span="8" :offset="6">
            <el-button type="text" @click="addPolygonalFence" :disabled="isPlatformUser">
              {{ $t('polygonalFence.addFence') }}
            </el-button>
          </el-col>
        </el-row>
        <el-table ref="tabRef"
                  :data="polygonalFenceList"
                  border
                  stripe
                  height="350"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" display="none"/>
          <el-table-column prop="fenceId" label="Fence Id" v-if="false"></el-table-column>
          <el-table-column prop="fenceName" :label="$t('polygonalFence.fenceName')" width="100px"></el-table-column>
          <el-table-column prop="userId" label="搜救员" width="100px" :formatter="userFormatter"></el-table-column>
          <!--        <el-table-column prop="inOut" :label="$t('polygonalFence.inOut')" :formatter="inOutFormatter" width="60px"></el-table-column>-->
          <el-table-column :label="$t('common.operation')" width="78px">
            <template slot-scope="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                @click="deleteFence(scope.row.fenceId)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="8">
            <el-button type="text" @click="openSearch">{{ $t('polygonalFence.query') }}</el-button>
          </el-col>
          <el-col :span="16">
            <el-input suffix-icon="el-icon-search" placeholder="请输入地址，按回车查询" v-model="searchAddress"
                      @change="searchByAddr"></el-input>
          </el-col>
        </el-row>
        <el-table ref="tabAddrRef"
                  :data="addressList"
                  border
                  stripe
                  height="350"
                  @selection-change="handleSelectionAddr">
          <el-table-column type="selection" align="center" display="none"/>
          <el-table-column prop="city" label="城市" width="80"></el-table-column>
          <el-table-column prop="name" label="地名"></el-table-column>
          <el-table-column prop="uid" label="uid" v-if="false"></el-table-column>
        </el-table>
      </el-aside>
      <div v-if="searchDialogVisible" class="searchClass">
        <el-card>
          <el-form :model="locatePoint"
                   ref="locatePointRef"
                   label-width="90px">
            <el-form-item :label="$t('polygonalFence.latitude')">
              <el-input type="number" v-model="locatePoint.lat"></el-input>
            </el-form-item>
            <el-form-item :label="$t('polygonalFence.longitude')">
              <el-input type="number" v-model="locatePoint.lng"></el-input>
            </el-form-item>
          </el-form>
          <el-button type="warning" @click="searchDialogVisible = false">{{ $t('common.close') }}</el-button>
          <el-button type="primary" @click="locate">{{ $t('common.search') }}</el-button>
        </el-card>
      </div>
      <el-main>
        <div class="circularFence">
          <GmapMap
            ref="mapRef"
            map-type-id="terrain"
            :center="{lat:25.037798, lng:121.565170}"
            v-if="currentMap === 'google'"
            :zoom="13"
            style="width: 100%; height: 100%"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUI: false
            }"></GmapMap>
          <baidu-map v-if="currentMap === 'baidu'" id="baiduMap" @ready="handleBaidu" style="width: 100%; height: 100%"
                     :scroll-wheel-zoom='true'>
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"/>
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"/>
          </baidu-map>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {getGpsDeviceByImei} from '@/api/gpsDevice'
import {checkLogin} from '@/api/globalProcessErr'
import {listPolygonalFence, deletePolygonalFence, insertPolygonalFence} from '@/api/polygonalFence'

import {
  initMap,
  moveToCenter,
  makeMarker,
  makePath,
  cleanMarks,
  makeTrackMarker,
  openInfoWindowByDeviceImei,
  cleanAllPath,
  cleanCurrentPath,
  centerAndZoom, baiduMapSuggestion
} from '@/api/map'
import {deviceStatusFormat, getObjString, objIsNull} from '@/api/util'
import {listUser} from "@/api/sysUser";
import axios from "axios";

export default {
  name: 'circularFence',
  data() {
    return {
      address: "",// 地址
      deviceImei: '',
      center: {
        lat: 22.5711440000,
        lng: 113.8687300000
      },
      polygonalFenceList: [],
      clickedPoint: {
        lat: undefined,
        lng: undefined
      },
      isPlatformUser: false,
      currentFence: {},
      device: undefined,
      mapInstance: undefined,
      devicePath: [],
      prePath: undefined,
      currentMap: 'baidu',
      currPath: undefined,
      deviceMark: {
        deviceImei: '',
        marker: undefined,
        infoWindow: undefined
      },
      addDialogVisible: false,
      addFenceForm: {
        fenceName: '',
        userId: undefined
      },
      pointList: [],
      locatePoint: {
        lat: undefined,
        lng: undefined
      },
      searchAddress: '',
      searchDialogVisible: false,
      createPoly: false,
      fenceList: [],
      userList: [],
      addressList: [],
    }
  },
  computed: {
    addFenceFormRules() {
      return {
        fenceName: [
          {required: true, message: this.$t('circularFence.rules.fenceName.required'), trigger: 'blur'}
        ],
        userId: [
          {required: true, message: '请指定搜救员', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.$i18n.locale = window.sessionStorage.getItem('lang')
    this.deviceImei = window.sessionStorage.getItem('polygonalFenceDeviceImei') || ''
    this.checkLang()
    this.getUserList()
    this.getPolygonalFenceList()
  },
  mounted() {
    const customerId = window.sessionStorage.getItem('selfCustomerId')
    if (customerId === '1') {
      this.isPlatformUser = true
    }
    const _this = this
    setTimeout(function () {
      _this.initMapPage()
      makeMarker(_this.mapInstance, _this.device)
      _this.drawPolygon()
    }, 600)
  },
  methods: {
    checkLang() {
      if (this.$i18n.locale === 'zh-CN') {
        this.currentMap = 'baidu'
      } else {
        this.currentMap = 'google'
      }
    },
    getUserList() {
      const _this = this
      const query = {
        pageNum: 1,
        pageSize: 1000
      }
      listUser(query).then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        _this.userList = res.data.data.list
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    handleBaidu({BMap, map}) {
      this.mapInstance = {
        mapType: 'baidu',
        map: map,
        bMap: BMap,
        // map: window.$BAIDU$._instances.TANGRAM__1,
        // bMap: window.BMap,
        markList: [],
        currentOpenInfoWindow: undefined,
        // TODO 改了  contentFunc: this.makeContent,
        contentFunc: this.makeInfoWindowContent,
        currentPoly: undefined,
        polyList: [],
        haveBtn: false,
        currentPoint: undefined,
        circleList: [],
        circleMarkList: [],
        clickFunc: this.clickFunc
      }
    },
    initMapPage() { // TODO 初始化地图
      if (this.currentMap === 'google') {
        if (this.mapInstance === undefined) {
          this.mapInstance = {
            mapType: 'google',
            map: this.$refs.mapRef.$mapObject,
            mapRef: this.$refs.mapRef,
            googleMaps: window.google.maps,
            markList: [],
            currentOpenInfoWindow: undefined,
          
             // TODO 改了  contentFunc: this.makeContent,
        contentFunc: this.makeInfoWindowContent,
            currentPoly: undefined,
            polyList: [],
            haveBtn: false,
            currentPoint: undefined,
            circleList: [],
            circleMarkList: [],
            clickFunc: this.clickFunc
          }
        }
      } else {
        if (this.mapInstance === undefined) {
          this.mapInstance = {
            mapType: 'baidu',
            // map: map,
            // bMap: BMap,
            map: window.$BAIDU$._instances.TANGRAM__1,
            bMap: window.BMap,
            markList: [],
            currentOpenInfoWindow: undefined,
           // TODO 改了  contentFunc: this.makeContent,
        contentFunc: this.makeInfoWindowContent,
            currentPoly: undefined,
            polyList: [],
            haveBtn: false,
            currentPoint: undefined,
            circleList: [],
            circleMarkList: [],
            clickFunc: this.clickFunc
          }
        }
      }
      initMap(this.mapInstance, this.center, 13)
    },
    // 弹窗内容
    makeContent(data, haveBtn) {
      const self = this
      // const motionStatus = self.motionStatusFormatter(data)
      return function () {
        let item = 'engine'
        let content = '<style>'
        content = content + '.deviceInfo{ padding: 0 0 0 0; margin: 0 0 0 0; .columnName{ width: 25%; } .columnValue{ width: 25%; }}'
        content = content + '</style>'
        content = content + '<div class="deviceInfo"><table frame="void">'
        content = content + '<tr align="left">'
        content = content + '<td class="columnName"><b> ' + self.$t('device.deviceImei') + '</b> : </td>'
        content = content + '<td class="columnValue">' + data.deviceImei + '</td>'
        content = content + '<td class="columnName"><b> ' + self.$t('device.deviceName') + '</b> : </td>'
        content = content + '<td class="columnValue">' + data.deviceName + '</td>'
        content = content + '</tr>'
        content = content + '<tr align="left">'
        content = content + '<td class="columnName"><b> ' + self.$t('device.lastLatitude') + '</b> : </td>'
        content = content + '<td class="columnValue">' + getObjString(data.lastLatitude) + '</td>'
        content = content + '<td class="columnName"><b> ' + self.$t('device.lastLongitude') + '</b> ：</td>'
        content = content + '<td class="columnValue">' + getObjString(data.lastLongitude) + '</td>'
        content = content + '</tr>'
        content = content + '</tr>'
        content = content + '<tr align="left">'
        content = content + '<td class="columnName"><b> ' + self.$t('device.accStatus') + '</b> : </td>'
        content = content + '<td class="columnValue">' + deviceStatusFormat(data, item) + '</td>'
        content = content + '<td class="columnName" ><b> ' + self.$t('device.lastLocationTime') + '</b> ：</td>'
        content = content + '<td class="columnValue" style="width: 160px;">' + getObjString(data.lastLocationTime) + '</td>'
        content = content + '</tr>'
        content = content + '<tr align="left">'
        content = content + '<td class="columnName"><b> ' + self.$t('device.lastSpeed') + '</b> : </td>'
        content = content + '<td class="columnValue">' + getObjString(data.lastSpeed) + '</td>'
        content = content + '<td class="columnName" ><b> ' + self.$t('device.heading') + '</b> ：</td>'
        content = content + '<td class="columnValue" >' + getObjString(data.heading) + '</td>'
        content = content + '</tr>'

        if (haveBtn) {
          content = content + '<tr><td> <button onclick="realTimeTrack(\'' + data.deviceImei + '\')" style="width: 150px;" type="button"> Real time tracking </button> </td>'
          content = content + '<td> <button onclick="historicalTrack(\'' + data.deviceImei + '\')" style="width: 150px; type="button"> Historical track </button> </td>'
          content = content + '<td> <button onclick="sendCommand(\'' + data.deviceImei + '\')" style="width: 150px; type="button"> Send Command </button></td>'
          content = content + '<td> <button onclick="getDeviceInfo(\'' + data.deviceImei + '\')" style="width: 150px; type="button"> Device Infomation</button> </td></tr>'
        }

        content += '</table></div>'

        return content
      }
    },
    // TODO 地点 弹窗内容
    makeInfoWindowContent(data) {
      // 使用箭头函数，不需要保存this到self变量
      return () => {
        let content = '<div><h4>' + this.address + '</h4></div>';
        return content;
      };
    },
    motionStatusFormatter(row, column) {
      if (row.lastMotionStatus === 1) {
        return 'motion'
      } else if (row.lastMotionStatus === 0) {
        return 'static'
      } else {
        return ''
      }
    },
    userFormatter(row, column) {
      for (let i = 0; i < this.userList.length; i++) {
        if (row.userId === this.userList[i].userId) {
          return this.userList[i].userName
        }
      }
    },
    openSearch() {
      this.searchDialogVisible = !this.searchDialogVisible
    },
    handleSelectionAddr(selection) {
      

      // TODO: 待优化
      // alert(selection)
      // 如果选择了多个项，则只保留第一个选择，并清除其他选择
      // if (selection.length > 1) {
      //   selection.shift()  
      //   this.$refs.tabAddrRef.clearSelection()
      //   this.$refs.tabAddrRef.toggleRowSelection(selection[0])
      // }

     
      // const uid = selection.map(item => item.uid)[0]
      // let selectedItem = {}
      // for(let i=0;i<this.addressList.length;i++){
      //   if(this.addressList[i].uid === uid){
      //     selectedItem = this.addressList[i]
      //     break
      //   }
      // }
         // 优化方法2 显示地址列表的长度（可能用于调试）
        // // 清除所有标记
        cleanMarks(this.mapInstance);
        // alert("传递："+selection.length); 
        if(selection.length == 1){
              // this.$refs.tabAddrRef.toggleRowSelection(selection[0]);
              this.address = selection[0].name;
             
            }
            else if (selection.length > 1) {
            
              selection.shift();
              this.$refs.tabAddrRef.clearSelection();
              if (selection.length > 0) {
                this.$refs.tabAddrRef.toggleRowSelection(selection[0]);
                  // alert(JSON.stringify(selection[0]) + "---------" + JSON.stringify(selection[0].location))
                 
                  this.address = selection[0].name;
              } else {
                // 如果移除后selection为空，则直接返回，避免后续无效操作
                return;
              }
          } 

            // 直接访问第一个元素的uid，而不是使用map
            const uid = selection[0]?.uid; // 使用可选链操作符进行空值保护
            if (!uid) {
              // 如果uid不存在，则直接返回，避免后续无效操作
              return;
            }

            // 使用find方法查找具有特定uid的元素
            const selectedItem = this.addressList.find(item => item.uid === uid) || {};

           
          

            // 检查selectedItem是否有效再调用相关方法
            if (selectedItem && selectedItem.location) {
              // 移到中心点
              this.moveToSuggestion(selectedItem);
              makeTrackMarker(this.mapInstance, selectedItem.location, 'start');
            }


          // // 如果选择了多个项，则只保留第一个选择，并清除其他选择
          // if (selection.length > 1) {
          //   const firstSelectedItem = selection.shift(); // 取出第一个元素并移除它
          //   this.$refs.tabAddrRef.clearSelection(); // 清除所有选择
          //   this.$refs.tabAddrRef.toggleRowSelection(firstSelectedItem); // 重新选择第一个元素
          // }

          // // 显示地址列表的长度（可能用于调试）
          // // alert(this.addressList.length);

          // // 获取当前选择项的UID（假设至少有一个选择项）
          // const uid = selection[0]?.uid; // 使用可选链操作符进行空值保护
          // if (!uid) {
          //   // 处理没有uid的情况，例如显示错误消息或返回
          //   // console.error('No UID found in the selection');
          //   return;
          // }

          // // 在地址列表中查找具有指定UID的项
          // const selectedItem = this.addressList.find(item => item.uid === uid) || {}; // 使用find方法，并提供一个空对象作为默认值



    //  TODO 使用 JSON.stringify() 来显示 selectedItem 的完整信息
      // alert(JSON.stringify(selectedItem) + "---------" + JSON.stringify(selectedItem.location))
      // this.makeInfoWindowContent("数据：");
      // // 清除所有标记
      // cleanMarks(this.mapInstance)
      // // 移到中心点
      // this.moveToSuggestion(selectedItem) 
      // makeTrackMarker(this.mapInstance, selectedItem.location, 'start')
    
    },
    searchByAddr() {
      if (!this.searchAddress) {
        return
      }
      let self = this
      let req = {
        query: self.searchAddress,
        ak: process.env.VUE_APP_BAIDU_AK
      }
      baiduMapSuggestion(req).then((res) => {
        if (res.data.code !== 0) {
          return self.$message.error(res.msg)
        }
        if (res.data.data){
          self.addressList = res.data.data
          if (self.addressList.length > 0){
            self.moveToSuggestion(self.addressList[0])
          }
        }
      }).catch(err => {
        return self.$message.error(err)
      })
    },
    moveToSuggestion(item){
      const center = item.location
      if (center){
        moveToCenter(this.mapInstance, center)
      }
    },
    addPolygonalFence() {
      if (this.isPlatformUser) {
        return this.$message.error('平台用户无权操作！')
      }

      if (this.pointList.length < 3) {
        return this.$message.error('请至少在地图上指定围栏的不少于3个点')
      }
      const self = this
      this.$refs.addFenceFormRef.validate(async valid => {
        // console.log(valid)
        // 表单预校验失败
        if (!valid) return

        const req = {
          deviceImei: self.deviceImei,
          fenceName: self.addFenceForm.fenceName,
          userId: self.addFenceForm.userId,
          pointList: self.pointList
        }
        insertPolygonalFence(req).then(res => {
          checkLogin(res)
          if (res.data.code !== 0) {
            return self.$message.error(res.data.msg)
          }
          self.$message.success('create success!')
          self.addDialogVisible = false
          self.pointList = []
          self.getPolygonalFenceList()
          setTimeout(function () {
            self.drawPolygon()
          }, 600)
          self.$refs.addFenceFormRef.resetFields()
          self.addFenceForm.fenceName = ''
          self.addFenceForm.inOut = undefined
        }).catch(err => {
          return self.$message.error(err.message)
        })
      })
    },
    async deleteFence(fenceId) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除所选围栏, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.error('已取消删除')
      }
      const req = {
        fenceId: fenceId
      }
      const self = this
      deletePolygonalFence(req).then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        self.$message.success('delete success!')
        self.getPolygonalFenceList()
        setTimeout(function () {
          self.drawPolygon()
        }, 600)
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    getPolygonalFenceList() {
      const self = this
      listPolygonalFence().then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return self.$message.error(res.data.msg)
        }
        self.polygonalFenceList = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    getGpsDevice() {
      getGpsDeviceByImei(this.deviceImei).then(res => {
        checkLogin(res)
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg)
        }
        this.device = res.data.data
      }).catch(err => {
        return this.$message.error(err.message)
      })
    },
    locate() {
      const self = this
      if (this.locatePoint.lat === undefined || this.locatePoint.lng === undefined) {
        return this.$message.error(self.$t('circularFence.rules.latLng'))
      }
      const center = {
        lat: Number(this.locatePoint.lat),
        lng: Number(this.locatePoint.lng)
      }
      if (center.lat > 90 || center.lat < -90) {
        return this.$message.warning(self.$t('circularFence.rules.lat'))
      }
      if (center.lng > 180 || center.lng < -180) {
        return this.$message.warning(self.$t('circularFence.rules.lng'))
      }
      moveToCenter(self.mapInstance, center)
    },
    clickFunc(e) {
      if (e !== undefined) {
        const point = {
          lng: e.lng,
          lat: e.lat
        }
        this.pointList.push(point)
        this.makeLine(this.pointList, true)
      }
    },
    makeLine(pointList, isCreate) {
      if (pointList.length <= 2) return
      let points = []
      for (let j = 0; j < pointList.length; j++) {
        points.push(pointList[j])
      }
      points.push(points[0])
      if (isCreate) {
        if (this.createPoly) {
          cleanCurrentPath(this.mapInstance)
        }
      }
      makePath(this.mapInstance, points)
      if (isCreate) {
        this.createPoly = true
      }
    },
    handleSelectionChange(selection) {
      if (selection.length > 1) {
        selection.shift()
        this.$refs.tabRef.clearSelection()
        this.$refs.tabRef.toggleRowSelection(selection[0])
      }

      this.currentFence.fenceId = selection.map(item => item.fenceId)[0]
      this.currentFence.userId = selection.map(item => item.userId)[0]
      this.currentFence.fenceName = selection.map(item => item.fenceName)[0]
      this.currentFence.inOut = selection.map(item => item.inOut)[0]
      this.currentFence.list = selection.map(item => item.list)[0]
      this.drawPolygon()
      this.mapToCenter()
    },
    drawPolygon() {
      cleanAllPath(this.mapInstance)
      if (this.currentFence.fenceId === undefined) {
        return
      }
      let pointList = []
      for (let j = 0; j < this.currentFence.list.length; j++) {
        let data = {
          lng: this.currentFence.list[j].longitude,
          lat: this.currentFence.list[j].latitude
        }
        pointList.push(data)
      }
      this.makeLine(pointList, false)
      this.createPoly = false
    },
    mapToCenter() {
      if (objIsNull(this.currentFence) || objIsNull(this.currentFence.fenceId)) {
        return
      }

      let points = this.currentFence.list
      centerAndZoom(this.mapInstance, points)
    },
  }
}
</script>

<style scoped>

::v-deep .el-table__header-wrapper .el-checkbox {
  display: none;
}

.el-aside {
  height: 100% !important;
  border-left: 0;
  border-right: 0;
  margin: 0 0 0 0;
  position: relative;
  /*font-size: xx-small;*/
}

.el-form {
  height: 100% !important;
  border-left: 0;
  border-right: 0;
  margin: 0 0 0 0;
  position: relative;
}

.el-main {
  height: 100%;
  width: calc(100% - 260px) !important;
  margin: 0 0 0 0;
  border-left: 0;
  border-right: 0;
  position: relative;
}

.circularFence {
  width: 100% !important;
  height: 900px !important;
  margin: 0 0 0 0;
  position: relative;

}

.searchClass {
  position: absolute;
  width: 230px;
  margin: 0 auto;
  left: 35%;
  z-index: 10;
  bottom: 30px;
}

.searchAddressClass {
  position: absolute;
  width: 230px;
  margin: 0 auto;
  left: 35%;
  z-index: 10;
  bottom: 30px;
}

.addFenceColumn {
  width: 130px;
}

</style>
